import { render, staticRenderFns } from "./AudioWidgetPanel.vue?vue&type=template&id=a4fb65ae&scoped=true"
import script from "./AudioWidgetPanel.vue?vue&type=script&lang=js"
export * from "./AudioWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./AudioWidgetPanel.vue?vue&type=style&index=0&id=a4fb65ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fb65ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4fb65ae')) {
      api.createRecord('a4fb65ae', component.options)
    } else {
      api.reload('a4fb65ae', component.options)
    }
    module.hot.accept("./AudioWidgetPanel.vue?vue&type=template&id=a4fb65ae&scoped=true", function () {
      api.rerender('a4fb65ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/editor/settingPanel/AudioWidgetPanel.vue"
export default component.exports